import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import { City } from './Cities.types';

const CONTROLLER_URL = `${API_BASE_URL}/cities`;

export async function listCitiesByState(
  state: string,
): Promise<PageResult<City>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/state/${state}`,
    null,
  )) as unknown;

  return result as PageResult<City>;
}

export async function getCity(id: number): Promise<City> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as City;
}
